<script lang="ts">
  import Badge from '../lib/ui/Badge.svelte';
  import Card from '../lib/ui/Card.svelte';
  import { Format } from '../lib/format';
  import { ReportChannel } from '../lib/report-channel';
  import type { ReportDefinitionsBoard } from '../lib/report-definitions-board.svelte';

  interface Props {
    board: ReportDefinitionsBoard;
  }

  let { board }: Props = $props();

  const now = new Date();
</script>

<Card title="Relatórios" count={board.overviews.length}>
  <div class="rows">
    {#if board.groups === null}
      <p class="empty">{board.error ? 'Não deu para carregar os relatórios.' : 'Carregando…'}</p>
    {:else}
      <div class="row head">
        <span class="label">Relatório</span><span class="label">Canais</span><span class="label">Clientes</span><span class="label"
          >Próximo envio</span
        >
      </div>
      {#each board.overviews as overview (overview.group.id)}
        <button class="row clickable" onclick={() => board.openGroup(overview.group.id)}>
          <span class="who">
            <span class="name">{overview.group.name}</span>
            <span class="sub mono">{overview.group.templateName}</span>
          </span>
          <span class="badges">
            {#each overview.group.channels as channel (channel)}
              <Badge tone="info">{ReportChannel.label(channel)}</Badge>
            {/each}
          </span>
          <span class="who">
            <span class="name">{Format.quantity(overview.clientCount, { one: 'cliente', many: 'clientes' })}</span>
            <span class="sub">{Format.quantity(overview.contactCount, { one: 'contato', many: 'contatos' })}</span>
          </span>
          <span class="sub">{overview.nextSendLabel(now)}</span>
        </button>
      {:else}
        <p class="empty">Nenhum relatório ainda.</p>
      {/each}
    {/if}
  </div>
  <p class="footnote">Cada relatório é um conjunto: os canais e o modelo do WhatsApp valem para todos os clientes dele</p>
</Card>

<style>
  .rows {
    display: flex;
    flex-direction: column;
  }
  .row {
    display: grid;
    grid-template-columns: minmax(0, 1.6fr) minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr);
    align-items: center;
    gap: var(--space-4);
    padding: var(--space-3) var(--space-2);
    border-top: 1px solid var(--border-subtle);
    border-radius: var(--radius-sm);
    text-align: left;
  }
  .head {
    border-top: none;
    padding-bottom: var(--space-2);
  }
  .clickable:hover {
    background: var(--bg-hover);
  }
  .who {
    display: flex;
    flex-direction: column;
    gap: 2px;
    min-width: 0;
  }
  .name {
    color: var(--text-primary);
    font-weight: 500;
  }
  .sub {
    color: var(--text-tertiary);
    font-size: 12px;
  }
  .label {
    font-size: 12px;
    font-weight: 500;
    color: var(--text-secondary);
    text-transform: uppercase;
    letter-spacing: 0.05em;
  }
  .badges {
    display: flex;
    flex-wrap: wrap;
    gap: var(--space-2);
  }
  .footnote,
  .empty {
    margin: var(--space-3) 0 0;
    color: var(--text-tertiary);
    font-size: 12px;
  }
</style>
